import { HttpStatusCode } from '@angular/common/http';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AUTH_SERVICE } from '@app/auth/auth.token';
import { IAuthService } from '@app/auth/interfaces/auth-service.interface';
import { AppRootRoute } from '@core/enums/app-route.enum';
import { ProfileService } from '@core/services/profile.service';
import { UserService } from '@shared/services/user.service';
import { catchError, Subject, takeUntil, tap, throwError } from 'rxjs';

@Component({
  selector: 'app-signing-in',
  templateUrl: './signing-in.component.html',
  styleUrls: ['./signing-in.component.scss'],
  standalone: true,
})
export class SigningInComponent implements OnInit, OnDestroy {
  private readonly compUnsubscribe$ = new Subject<void>();

  constructor(
    private readonly router: Router,
    private readonly profileService: ProfileService,
    @Inject(AUTH_SERVICE) private readonly authService: IAuthService,
    private readonly userService: UserService
  ) {}

  ngOnInit(): void {
    this.userService
      .onSignIn()
      .pipe(
        tap(() => {
          this.profileService.setUserActiveState(true);
          this.authService.init();
          this.authService.handleAfterLoggedIn();
          this.router.navigate([AppRootRoute.HOME]);
        }),
        catchError(error => {
          if (error.status === HttpStatusCode.Unauthorized)
            this.authService.logout();

          return throwError(() => error);
        }),
        takeUntil(this.compUnsubscribe$)
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.compUnsubscribe$.next();
    this.compUnsubscribe$.complete();
  }
}
